import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Validate Indian Mobile Number",
  url: "validate-indian-mobile-number",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {string} str
* @return {boolean}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function validateMobileNumber(str) {
  // your code goes here        
};
`,
};

export default info;
